// @ts-ignore
import { hasProp, assert } from "@utils/assertion";
// @ts-ignore
import { isArray } from "@utils/arrayUtils";
// @ts-ignore
import { parseJsonWithNumbersAsBigint, renderJsonWithNumbersAsBigint, type ParserResult } from "@utils/json";
// @ts-ignore
import { toBase64 } from "@utils/blobUtils";
// @ts-ignore
import { DateTime } from "luxon";
// @ts-ignore
import { type ReadonlyUint8Array } from "@utils/arrayUtils";
import type { OutboundLinkType } from "../schema";

export function serialize_OutboundLinkType_internal(value: OutboundLinkType): unknown {
  return ((value: "GENERIC" | "BUYBOOK" | "MIAB_SCHEDULE" | "ACTIONABLE_SCHEDULE" | "SUMMARY_SCHEDULE" | "VERIFY_SCHEDULE" | "VERIFY_SOURCE"): unknown => {
    return value;
  })(value);
}
export function serialize_OutboundLinkType(obj: OutboundLinkType): string {
  return renderJsonWithNumbersAsBigint(serialize_OutboundLinkType_internal(obj));
}
export function deserialize_OutboundLinkType_internal(value: unknown): ParserResult<OutboundLinkType> {
  return ((value: unknown): ParserResult<"GENERIC" | "BUYBOOK" | "MIAB_SCHEDULE" | "ACTIONABLE_SCHEDULE" | "SUMMARY_SCHEDULE" | "VERIFY_SCHEDULE" | "VERIFY_SOURCE"> => {
    if (typeof value !== "string") {
      return { success: false, reason: `[#/components/schemas/OutboundLinkType]: '${value}' expected to be of type string.` };
    }
    switch (value) {
      case "GENERIC":
        return { success: true, value: "GENERIC" };
      case "BUYBOOK":
        return { success: true, value: "BUYBOOK" };
      case "MIAB_SCHEDULE":
        return { success: true, value: "MIAB_SCHEDULE" };
      case "ACTIONABLE_SCHEDULE":
        return { success: true, value: "ACTIONABLE_SCHEDULE" };
      case "SUMMARY_SCHEDULE":
        return { success: true, value: "SUMMARY_SCHEDULE" };
      case "VERIFY_SCHEDULE":
        return { success: true, value: "VERIFY_SCHEDULE" };
      case "VERIFY_SOURCE":
        return { success: true, value: "VERIFY_SOURCE" };
      default:
        return { success: false, reason: `[#/components/schemas/OutboundLinkType]: '${value}' expected to be enum, one of 'GENERIC, BUYBOOK, MIAB_SCHEDULE, ACTIONABLE_SCHEDULE, SUMMARY_SCHEDULE, VERIFY_SCHEDULE, VERIFY_SOURCE'.` };
    }
  })(value);
}
export function deserialize_OutboundLinkType(str: string): ParserResult<OutboundLinkType> {
  return deserialize_OutboundLinkType_internal(parseJsonWithNumbersAsBigint(str));
}
